var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quarter-content"},[_c('h1',[_vm._v(_vm._s(_vm.content.number))]),_c('h2',[_vm._v(_vm._s(_vm.content.topic))]),_c('p',[_vm._v(_vm._s(_vm.content.txt))])])}
var staticRenderFns = []

export { render, staticRenderFns }